import { MeteringPoint } from "./metering-point";
import { ContractPeriod, ElectricityPackage } from "./new-electricity-agreement";

export interface ElectricityAgreement {
    id: number;
    contractNumber: string;
    customer: ElectricityAgreementCustomer;
    contactPerson: ElectricityAgreementContactPerson;
    dateCreated: string;
    dateModified: string;
    startDate?: string;
    endDate?: string;
    productionPackage: ElectricityPackage;
    consumptionPackage: ElectricityPackage;
    consumptionMarginal: number;
    productionMarginal: number;
    basePriceCentsKwh?: number;
    baseConsumptionProportion?: number;
    dayTariffCentsKwh?: number;
    nightTariffCentsKwh?: number;
    monthlyFeeEuros?: number;
    earlyTerminationFee?: number;
    estimatedConsumptionVolumeMwh?: number;
    estimatedConsumptionDayVolumeMwh?: number;
    estimatedConsumptionNightVolumeMwh?: number;
    fileName: string;
    status: ElectricityAgreementStatus;
    meteringPoints: MeteringPoint[];
    consolidatedInvoice: boolean;
    offerDeadline?: string;
    contractPeriod?: ContractPeriod;
    guarantee?: number;
}

export interface SimpleElectricityAgreement {
    id: number;
    name: string;
    startDate: string;
}

interface ElectricityAgreementCustomer {
    id: number;
    name: string;
    registryNumber: string;
    address: string;
    city?: string;
    zip?: string;
    county?: string;
    bankAccountNumber?: string;
    electricityInvoiceRecipientEmail?: string;
    eInvoice: boolean;
}

interface ElectricityAgreementContactPerson {
    id: number;
    name: string;
    email: string;
    phone: string;
}

export enum ElectricityAgreementStatus {
    ACTIVE = 'ACTIVE',
    ENDED = 'ENDED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    CANCELED = 'CANCELED'
}

export const ELECTRICITY_AGREEMENT_STATUS_MAP: {[key in ElectricityAgreementStatus]: string} = {
    ACTIVE: 'Kehtiv',
    ENDED: 'Lõppenud',
    PENDING: 'Kinnitamise ootel',
    REJECTED: 'Tagasi lükatud',
    CANCELED: 'Tühistatud'
};